import { Input } from "components/form";
import CustomModal from "components/modals/CustomModal";
import { getFromLocal, removeToken } from "config/axiosInstance";
import useButtonLoader from "hooks/useButtonLoader";
import useNavigation from "hooks/useNavigation";
import usePasswordToggle from "hooks/usePasswordToggle";
import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { userChangePasswordAPi, userLogoutApi } from "services/userProfile";
import { toastMessage } from "utils/toastMessageHelper";
import { removeErrorFields, validateInput } from "validation";
import { userProfile } from "validation/schema/userProfile";

const ChangeUserPassword = () => {
  const { navigateTo } = useNavigation();

  // set all value
  const [inputData, setInputData] = useState({});
  const [changePasswordModal, setChangePasswordModal] = useState(false);
  const [error, setError] = useState({});
  const { t } = useTranslation();

  // hooks
  const [confirmInputType1, icon1] = usePasswordToggle();
  const [confirmInputType2, icon2] = usePasswordToggle();
  const [confirmInputType, icon] = usePasswordToggle();
  const [changePasswordButtonLoader, setChangePasswordButtonLoader] =
    useButtonLoader("Yes");

  // Input change handler
  const changeHandler = (event) => {
    const { name, value } = event.target;
    setInputData({ ...inputData, [name]: value });
    setError((prevError) => removeErrorFields(prevError, name));
  };

  // Validate Input Data
  const validation = () => {
    const { errors, status } = validateInput(
      inputData,
      "changeUserPasswordSchema",
      userProfile,
      null
    );
    setError(errors);
    return status;
  };

  // Update Password handler
  const updatePasswordHandler = (e) => {
    e.preventDefault();
    if (validation()) {
      setChangePasswordModal(true);
    }
  };

  // check mis-match password
  const checkMisMatchPassword = () => {
    if (inputData?.newPassword !== inputData?.confirmPassword) {
      toastMessage("Password mis-match", "warning", "userResetPassword");
      return false;
    }
    return true;
  };

  // Close User Change Password modal
  const closeUserPasswordModal = () => {
    setInputData({});
    setError({});
    setChangePasswordModal(false);
  };

  // User Change Password Api Handler

  const userChangePasswordHandler = async (e) => {
    e.preventDefault();
    if (validation() && checkMisMatchPassword) {
      try {
        setChangePasswordButtonLoader(true);
        const reqData = { ...inputData, token: getFromLocal("token") };
        const responseData = await userChangePasswordAPi(reqData);
        const { message: logOutMessage = "", status } = responseData;
        if (status === 200) {
          const reqData = { token: getFromLocal("token") };
          const responseData = await userLogoutApi(reqData);
          const { message = "", status } = responseData;
          if (status === 200) {
            closeUserPasswordModal();
            toastMessage(logOutMessage, "success", "userChangePassword");
            removeToken();
            navigateTo("/");
          }
        } else {
          toastMessage(logOutMessage, "error", "userChangePassword");
        }
      } catch (e) {
        console.log("Error:", e.message);
      } finally {
        setChangePasswordButtonLoader(false);
      }
    }
  };

  return (
    <>
      <div className="_card">
        <h3 className="sub_title">{t("EDIT_PROFILE.changePassword")}</h3>

        <div className="form_field_wrap">
          <div className="form_field password">
            <Input
              type={confirmInputType1}
              placeholder={t("EDIT_PROFILE.enterOldPassword")}
              label={t("EDIT_PROFILE.oldPassword")}
              name="oldPassword"
              value={inputData?.oldPassword}
              onChange={changeHandler}
              error={error?.oldPassword}
              extraError={error?.oldPasswordErr}
            />
            <span className="password_icons">{icon1}</span>
          </div>
          <div className="form_field password">
            <Input
              type={confirmInputType2}
              placeholder={t("EDIT_PROFILE.enterNewPassword")}
              label={t("EDIT_PROFILE.newPassword")}
              name="newPassword"
              value={inputData?.newPassword}
              onChange={changeHandler}
              error={error?.newPassword}
              extraError={error?.newPasswordErr}
            />
            <span className="password_icons">{icon2}</span>
          </div>
        </div>
        <div className="form_field_wrap">
          <div className="form_field password">
            <Input
              name="confirmPassword"
              type={confirmInputType}
              onChange={changeHandler}
              label={t("EDIT_PROFILE.confirmPassword")}
              error={error?.confirmPassword}
              value={inputData?.confirmPassword}
              placeholder={t("EDIT_PROFILE.enterConfirmPassword")}
              extraError={error?.confirmPasswordErr}
            />
            <span className="password_icons">{icon}</span>
          </div>
          <div className="form_field"></div>
        </div>
        <div className="button_wrap button_right">
          <Button type={"button"} onClick={updatePasswordHandler}>
            {t("EDIT_PROFILE.updatePassword")}
          </Button>
        </div>
      </div>

      {/* User Change Password */}

      {changePasswordModal && (
        <CustomModal
          show={changePasswordModal}
          handleClose={closeUserPasswordModal}
          className={"chnagePassword"}
        >
          <div className="wrap_log_modal">
            <h3>{t("EDIT_PROFILE.sureChangePassword")}</h3>
            <div className="button_wrap button_center">
              <Button
                className={"light"}
                ref={changePasswordButtonLoader}
                onClick={userChangePasswordHandler}
              >
                {t("COMMON.yes")}
              </Button>
              <Button className="mx-2" onClick={closeUserPasswordModal}>
                {t("COMMON.no")}
              </Button>
            </div>
          </div>
        </CustomModal>
      )}
    </>
  );
};

export default ChangeUserPassword;
